import { PATH_NAME } from "../configs/pathName";
import { ICart, ICartUpdatePayload } from "../models/ICart";
import axiosInstance from "./axiosInstance";

export const getCartItems = async (): Promise<ICart> => {
    const response = await axiosInstance.get(PATH_NAME.API_GET_CART_ITEMS);
    return response.data.result;
}

export const updateCartItem = async (cart: ICartUpdatePayload) => {
    const response = await axiosInstance.put(PATH_NAME.API_UPDATE_CART_ITEM, cart);
    return response.data.result as ICart;
}